import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import * as toastr from 'toastr';
import { ProjectConstants } from 'src/app/project-constants';
import { Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogDetailComponent } from '../dialog-detail/dialog-detail.component';
import { NumAnnoMeseFilterComponent } from '../filter/num-anno-mese-filter/num-anno-mese-filter.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Offset } from 'src/models/OffsetModel';
import * as FileSaver from 'file-saver';
import { ContractualValuesService } from 'src/app/contractual-data/contractual-values/service-contractual-values/contractual-values.service';
import {ReimbursmentService} from '../../contractual-data/reimbursment/service-reimbursment/reimbursment.service';
import {TerminationFeeService} from '../../contractual-data/termination-fee/service-termination-fee/termination-fee.service';
import {ConsuntivoVolumiService} from '../../monthly-actual/consuntivo-volumi/service-consuntivo-volumi/consuntivo-volumi.service';
import {ConsuntivoVolumiScartoService} from '../../monthly-actual/consuntivo-volumi-scarto/service-consuntivo-volumi-scarto/consuntivo-volumi-scarto.service';
import {DeltaVolumiService} from '../../monthly-actual/delta-volumi/service-delta-volumi/delta-volumi.service';
import {ForecastVolumiService} from '../../monthly-actual/forecast-volumi/service-forecast-volumi/forecast-volumi.service';
import {CalculatedChargesService} from '../../monthly-charges/calculated-charges/service-calculated-charges/calculated-charges.service';
import {ConsuntivoChargesService} from '../../monthly-charges/consuntivo-charges/service-consuntivo-charges/consuntivo-charges.service';
import {DeltaChargesService} from '../../monthly-charges/delta-charges/service-delta-charges/delta-charges.service';
import { ChargesScartoService } from 'src/app/monthly-charges/waste-charges/service-charges-scarto/charges-scarto.service';

@Component({
  selector: 'app-dialog-year-month',
  templateUrl: './dialog-year-month.component.html',
  styleUrls: ['./dialog-year-month.component.scss']
})
export class DialogYearMonthComponent extends ProjectConstants implements OnInit {

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;

    dataValues: Array<any>;
    getPageSubscribe: Subscription;
    updateNotes: Subscription;
    getNameSubscribe: Subscription;
    numAnnoMeseFrom: number;
    numAnnoMeseTo: number;
    registerForm: FormGroup;
    allMonth: any;
    serviceReportPage: string;
    filter: any;
    offset: Offset;
    loader: boolean;

    constructor(public dialogData: MatDialogRef<DialogDetailComponent>,
                @Inject(MAT_DIALOG_DATA) data,
                private formBuilder: FormBuilder,
                private contractualValuesService: ContractualValuesService,
                private reimbursmentService: ReimbursmentService,
                private terminationFeeService: TerminationFeeService,
                private consuntivoVolumiService: ConsuntivoVolumiService,
                private consuntivoVolumiScartoService: ConsuntivoVolumiScartoService,
                private deltaVolumiService: DeltaVolumiService,
                private forecastVolumiService: ForecastVolumiService,
                private calculatedChargesService: CalculatedChargesService,
                private consuntivoChargesService: ConsuntivoChargesService,
                private chargesScartoService: ChargesScartoService,
                private deltaChargesService: DeltaChargesService,



    ) {
        super();
        this.dataValues = data.list;
    }

    ngOnInit() {
      this.loader = true;
      this.filter = this.dataValues[0]['value'];
      this.offset = this.dataValues[1]['value'];
      this.allMonth = this.dataValues[2]['value'];
      this.serviceReportPage = this.dataValues[3]['value'];


      this.registerForm = this.formBuilder.group({
        annoMeseFrom: [{value: this.numAnnoMeseFrom, disabled: false}, Validators.required],
        annoMeseTo: [{value: this.numAnnoMeseFrom, disabled: false}, Validators.required]});
      this.loader = false;
    }

    save() {
      this.downloadXlsx();
    }

    downloadXlsx() {
      this.loader = true;

      switch( this.serviceReportPage ) {
        case this.SERVICE_REPORT_DOWNLOAD.CONTRACTUAL_VALUES_SERVICE: {
          this.generateContractualValuesXlsx();
          break;
        }
        case this.SERVICE_REPORT_DOWNLOAD.TERMINATION_FEE_SERVICE: {
          this.generateTerminationFeeXlsx();
          break;
        }
        case this.SERVICE_REPORT_DOWNLOAD.REIMBURSMENT_SERVICE: {
          this.generateReimbursmentXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI: {
          this.generateConsuntivoVolumiXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI_SCARTO: {
          this.generateConsuntivoVolumiScartoXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.DELTA_VOLUMI: {
          this.generateDeltaVolumiXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.FORECAST_VOLUMES: {
          this.generateForecastVolumesXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.CALCULATED_CHARGES: {
          this.generateCalculatedChargesXlsx();
          break;
        }
        case this.SERVICE_REPORT_DOWNLOAD.CONSUMPTIVE_CHARGES: {
          this.generateConsumptiveChargesXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.CONSUMPTIVE_CHARGES_WASTE: {
          this.generateConsumptiveChargesWasteXlsx();
          break;
        }

        case this.SERVICE_REPORT_DOWNLOAD.DELTA_CHARGES: {
          this.generateDeltaChargesXlsx();
          break;
        }



        default: {
          this.generateContractualValuesXlsx();
          break;
        }
      }


    }

  getDate(){
    const date = new Date();

    return date.getFullYear() + '_' +
      String(date.getMonth() + 1).padStart(2, '0')+'_'+
      String(date.getDate()).padStart(2, '0');
  }


    getAnnoMese(annoMese: number ): string {
      const year = Number(annoMese.toString().substring(0, 4));
      const month = Number(annoMese.toString().substring(4, 6));

      const options = { month: 'long', year: 'numeric' };
      const parsedYearMonth = new Date(year, month - 1);

      return parsedYearMonth.toLocaleDateString('en-US', options);
    }

    handleNumAnnoMeseFrom(value) {
      this.numAnnoMeseFrom = value;
      this.filter.numAnnoMeseFrom = this.numAnnoMeseFrom;
    }
    handleNumAnnoMeseTo(value) {
      this.numAnnoMeseTo = value;
      this.filter.numAnnoMeseTo = this.numAnnoMeseTo;
    }

    close() {
      this.dialogData.close();
    }

    generateContractualValuesXlsx() {
    this.getNameSubscribe = this.contractualValuesService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Contractual_Values_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Contractual_Values_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateTerminationFeeXlsx() {
    this.getNameSubscribe = this.terminationFeeService.getNameGenerateXlsx(this.offset, this.filter)
    .subscribe(
      resultPage => {
        const currentDate = this.getDate();
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(
            new Blob([resultPage],
              { type: this.EXCEL_TYPE }),
            'Termination_fee' + currentDate + '.xlsx');
        } else {
          FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Termination_fee_' + currentDate + '.xlsx');
        }
        toastr.success('XLS downloaded with success', 'Success');
        this.close();
        this.loader = false;
      }, () => {
        this.close();
        toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
        this.loader = false;
      });
    }

    generateReimbursmentXlsx() {
    this.getNameSubscribe = this.reimbursmentService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Reimbursment_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Reimbursment_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateConsuntivoVolumiXlsx() {
    this.getNameSubscribe = this.consuntivoVolumiService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Volume_Consumptive_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Volume_Consumptive_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateConsuntivoVolumiScartoXlsx() {
     this.getNameSubscribe = this.consuntivoVolumiScartoService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Volume_Consumptive_Waste_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Volume_Consumptive_Waste_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateDeltaVolumiXlsx() {
    this.getNameSubscribe = this.deltaVolumiService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Delta_Volumes_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Delta_Volumes_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateForecastVolumesXlsx() {
    this.getNameSubscribe = this.forecastVolumiService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Forecast_Volumes_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Forecast_Volumes_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateCalculatedChargesXlsx() {
    this.getNameSubscribe = this.calculatedChargesService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Calculated_Charges_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Calculated_Charges_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

    generateConsumptiveChargesXlsx() {
    this.getNameSubscribe = this.consuntivoChargesService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Consumptive_Charges_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Consumptive_Charges_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

  generateConsumptiveChargesWasteXlsx () {
    this.getNameSubscribe = this.chargesScartoService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Consumptive_Charges_Waste_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Consumptive_Charges_Waste_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
    }

  generateDeltaChargesXlsx () {
    this.getNameSubscribe = this.deltaChargesService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              'Delta_Charges_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),  'Delta_Charges_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.close();
          this.loader = false;
        }, () => {
          this.close();
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loader = false;
        });
  }
}
